import React from 'react';
import {
  Box,
  Container,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import { CalendarToday as CalendarIcon, Edit as EditIcon } from '@mui/icons-material';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import HabitLogForm from '../components/HabitLogForm';
import NotionLink from '../components/NotionLink';
import TabPanel from '../components/TabPanel';

const TodayPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine current tab based on URL
  const getCurrentTab = () => {
    if (location.pathname.includes('/log-habits')) {
      return 0;
    } else if (location.pathname.includes('/pasos')) {
      return 1;
    }
    return 0;
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) {
      navigate('/today/log-habits');
    } else if (newValue === 1) {
      navigate('/today/pasos');
    }
  };

  const handleLogSuccess = () => {
    // Optionally switch to reports tab or refresh data
    // navigate('/today/pasos');
  };

  return (
    <Box>
      <Paper elevation={1} square sx={{ mb: 4 }}>
        <Tabs
          value={getCurrentTab()}
          onChange={handleTabChange}
          centered
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            icon={<EditIcon />}
            label="Log Habits"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
          <Tab
            icon={<CalendarIcon />}
            label="Pasos"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
        </Tabs>
      </Paper>

      <Container maxWidth="lg" sx={{ px: { xs: 1.5, sm: 2, md: 3 } }}>
        <Routes>
          <Route path="/" element={<Navigate to="/today/log-habits" replace />} />
          <Route path="/log-habits/*" element={
            <TabPanel value={getCurrentTab()} index={0}>
              <HabitLogForm onSuccess={handleLogSuccess} />
            </TabPanel>
          } />
          <Route path="/pasos/*" element={
            <TabPanel value={getCurrentTab()} index={1}>
              <NotionLink />
            </TabPanel>
          } />
        </Routes>
      </Container>
    </Box>
  );
};

export default TodayPage;